/**
 * src/config/env.ts
 * ------------------
 * What: Resolves environment variables for dev vs prod builds and exposes a
 * typed config object the rest of the app can import.
 * Why: Centralises environment selection and validation so modules do not need
 * to read from `process.env` directly.
 */
// Debug logging
// console.log('==== ENV.TS IS RUNNING ====');
// console.log('NODE_ENV:', process.env.NODE_ENV);

const isProd = process.env.NODE_ENV === 'production';
// console.log('Raw Environment Variables:', isProd ? {
//   EXPO_PUBLIC_SUPABASE_URL_PROD: process.env.EXPO_PUBLIC_SUPABASE_URL_PROD,
//   EXPO_PUBLIC_SUPABASE_ANON_KEY_PROD: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY_PROD,
//   EXPO_PUBLIC_API_URL_PROD: process.env.EXPO_PUBLIC_API_URL_PROD,
// } : {
//   EXPO_PUBLIC_SUPABASE_URL_DEV: process.env.EXPO_PUBLIC_SUPABASE_URL_DEV,
//   EXPO_PUBLIC_SUPABASE_ANON_KEY_DEV: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY_DEV,
//   EXPO_PUBLIC_API_URL_DEV: process.env.EXPO_PUBLIC_API_URL_DEV,
// });

const ENV = {
  dev: {
    supabaseUrl: process.env.EXPO_PUBLIC_SUPABASE_URL_DEV,
    supabaseAnonKey: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY_DEV,
    apiUrl: process.env.EXPO_PUBLIC_API_URL_DEV,
  },
  prod: {
    supabaseUrl: process.env.EXPO_PUBLIC_SUPABASE_URL_PROD,
    supabaseAnonKey: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY_PROD,
    apiUrl: process.env.EXPO_PUBLIC_API_URL_PROD,
  },
};

const getEnvVars = () => {
  // Default to development environment
  const env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev';
  const selectedEnv = ENV[env as keyof typeof ENV] || ENV.dev;
  // Validate environment variables
  if (!selectedEnv.supabaseUrl || !selectedEnv.supabaseAnonKey) {
    throw new Error('Missing required environment variables');
  }
  return selectedEnv;
};

export default getEnvVars(); 